<template lang='pug'>
  .app-body
    .row
      .col-sm-10
        h1 {{ $tc('js.award.title', countFull, { firma: firma, count: countFull }) }}
      .col-sm-2
        img.img-responsive.pull-right(:src="logo")
    br
    p {{ $t('js.award.body', bodyI18nArgs) }}
    br
    br
    .row.top-row
      .col-lg-4.col-12
        card(
          :id='id'
          color='#532080'
          :title="$t('js.award.satisfaction_process.title')"
          :subtitle="$t('js.award.satisfaction_process.subtitle')"
          icon="fa-star-half-o"
          type="cxp_public_score:satisfaction_process"
          :scale="true"
          v-model="satisfaction_process"
        )
      .col-lg-4.col-12
        card(
          :id='id'
          color='#532080'
          :title="$t('js.award.would_recommend.title')"
          :subtitle="$t('js.award.would_recommend.subtitle')"
          icon="fa-comment-o"
          v-model="would_recommend"
          type="cxp_public_score:would_recommend"
        )
      .col-lg-4.col-12
        card(
          :id='id'
          color='#532080'
          :title="$t('js.award.award.title')"
          icon="fa-trophy"
          :custom="true"
        )
          .row
            .col-sm-4
              img.img-responsive(:src="image" width="130")
            .col-sm-8
              .satisfaction(v-html="satisfaction")
              strong  {{ $tc('js.award.award.this_year', count, { count: count }) }}
              br
              .text-muted {{ $tc('js.award.award.one_year_ago', countOneYearAgo, { count: countOneYearAgo }) }}
    .row
      .col-md-6.col-lg-3
        card(
          :id='id'
          color='#b779f2'
          :title="$t('js.award.first_contact.title')"
          :subtitle="$t('js.award.first_contact.subtitle')"
          icon="fa-handshake-o"
          prefix="r"
          :scale="true"
          type="cxp_public_score:satisfaction_first_contact"
          v-model="first_contact"

        )
      .col-sm-6.col-lg-3
        card(
          :id='id'
          color='#b779f2'
          :title="$t('js.award.interview.title')"
          :subtitle="$t('js.award.interview.subtitle')"
          prefix="s"
          icon="fa-comments-o"
          :scale="true"
          type="cxp_public_score:satisfaction_with_interview"
          v-model="interview"
        )
      .col-md-6.col-lg-3
        card(
          :id='id'
          color='#b779f2'
          :title="$t('js.award.rejection.title')"
          :subtitle="$t('js.award.rejection.subtitle')"
          icon="fa-times"
          :scale="true"
          type="cxp_public_score:satisfaction_with_rejection"
          v-model="rejection"
        )
      .col-md-6.col-lg-3
        card(
          :id='id'
          color='#b779f2'
          :title="$t('js.award.negotiation.title')"
          :subtitle="$t('js.award.negotiation.subtitle')"
          icon="fa-check"
          :scale="true"
          type="cxp_public_score:satisfaction_with_negotiation"
          v-model="negotiation"
        )

</template>

<script>
import Card from 'award/components/Card.vue';

const cxp_color = (type) => {
  switch (type) {
    case "before_application":
      return ["#67a5ce", "#43708c", "#67a5ce", "#5c94b9", "#5284a4", "#487390", "#3d637b", "#335267", "#294252", "#1e313d", "#142129"];
    case "first_contact":
      return ["#67ce89", "#3f935a", "#388451","#327548","#2c663e","#255836","#1f492d","#193a24","#122c1b", "#76aed2", "#85b7d7", "#94c0dc", "#a3c9e1", "#b3d2e6", "#c2dbeb"];
    case "interview":
      return ["#ce6f67", "#7f4843", "#71403c", "#633834", "#55302d", "#472825", "#38201e", "#2a1816", "#1c100f", "#d27d76", "#d78b85", "#dc9a94", "#e1a8a3", "#e6b7b3", "#ebc5c2", "#f0d3d1"];
    case "rejection":
      return ["#ce9a67", "#936c48", "#846140", "#755639", "#664b32", "#58402b", "#493624", "#3a2b1c", "#2c2015", "#d2a476", "#d7ae85", "#dcb894", "#e1c2a3", "#e6ccb3", "#ebd6c2", "#f0e0d1", "#f5eae0"];
    case "acceptance":
      return ["#cecb67", "#9b984d", "#8b8845", "#7c793d", "#6c6a35", "#5d5b2e", "#4d4c26", "#3e3c1e", "#2e2d17", "#d2d076", "#d7d585", "#dcda94", "#e1dfa3", "#e6e5b3", "#ebeac2", "#f0efd1"];
    default:
      return [];
      // "#c2c2c2", "#939393"
  }
}

export default {
  components: {
    Card
  },
  props: {
    firma: { type: String, required: true },
    id: { type: Number, required: true },
    count: { type: Number, required: true },
    countOneYearAgo: { type: Number, required: true },
    countFull: { type: Number, required: true },
    logo: { type: String, required: true },
  },
  data() {
    return {
      satisfaction_process: 0,
      would_recommend: 0,
      first_contact: 0,
      negotiation: 0,
      rejection: 0,
      interview: 0
    }
  },
  computed: {
    bodyI18nArgs() {
      const toAdjektiv = (score) => {
        if (score == 4.7) {
          return this.$t("js.award.adjektiv.best")
        } else if (score >= 3.7) {
          return this.$t("js.award.adjektiv.very_good")
        } else if (score >= 2.7) {
          return this.$t("js.award.adjektiv.good")
        } else {
          return this.$t("js.award.adjektiv.improvement")
        }
      }
      const intl = new Intl.NumberFormat(this.$i18n.locale, { maximumFractionDigits: 1 })
      const intlPercent = new Intl.NumberFormat(this.$i18n.locale, { style: 'percent' })
      return {
        firma: this.firma,
        satisfactionProcess: intl.format(this.satisfaction_process),
        satisfactionProcessText: toAdjektiv(this.satisfaction_process),
        wouldRecommend: intlPercent.format(this.would_recommend / 100),
        firstContact: toAdjektiv(this.first_contact),
        interview: toAdjektiv(this.interview),
        rejection: toAdjektiv(this.rejection),
        negotiation: toAdjektiv(this.negotiation),
      }
    },
    satisfaction() {
      if (this.satisfaction_process && this.would_recommend) {
        const score = (this.would_recommend / 100 * 5 + this.satisfaction_process) / 2
        if (score >= 4.7) {
          return this.$t("js.award.candidate_management.best")
        } else if (score >= 3.7) {
          return this.$t("js.award.candidate_management.very_good")
        } else if (score >= 2.7) {
          return this.$t("js.award.candidate_management.good")
        }
      }
      return ""
    },
    image() { return `https://${window.location.hostname}/award/${this.id}.png` },
  },
  methods: {
    color(channel) {
      return cxp_color(channel)[0]
    },
  }
}
</script>
<style scoped>
.satisfaction{
  color: #532080;
  font-size: 20px;
  margin-bottom: 15px;
}
</style>

